




















































































































































import Vue from 'vue'
import SelectDesign from '@/stockLibrary/components/SelectDesign.vue'
import ProductGeneralInfo from '@/stockLibrary/components/product/ProductGeneralInfo.vue'
import ProductList from '@/stockLibrary/components/product/ProductList.vue'
import ProductCardGender from '@/common/components/productCard/ProductCardGender.vue'
import ProductDetail from '@/stockLibrary/components/product/ProductDetail.vue'
import DesignPreview from '@/stockLibrary/components/DesignPreview.vue'
import ProductEditPattern from '@/stockLibrary/components/product/ProductEditPattern.vue'
import Header from '@/stockLibrary/components/Header.vue'
import LandingModal from '@/stockLibrary/components/LandingModal.vue'
import ModalIntroduction from '@/stockLibrary/components/ModalIntroduction.vue'

import {
  StockLibraryInitRes,
  DesignImage,
  FullColorCategory,
  SimplifiedProductByCategory,
  SimplifiedEditPattern,
  ProductDetailRes,
  ProductDetail as ProductDetailModel,
  CategoryEditPatternRes,
  ProductEditPatternModel,
  ProductEditPatternsRes,
  CrossSellNamingEditor,
  CrossSellData
} from '@/stockLibrary/queries/types'

import {
  getInitStockLibraryData,
  getProductDetail,
  getCategoryEditPatterns,
  getProductEditPatternsByFirstOption,
  getCrossSellData
} from '@/stockLibrary/services'

import LocalStorageSerializer from '@/common/localStorageSerializer'
import {
  TutorialStep,
  TUTORIAL_STEPS
} from '@/stockLibrary/config/tutorial'

import { LOCAL_STORAGE_TUTORIAL_DISABLED, LOCAL_STORAGE_CROSS_SELL_MODAL_DISABLED } from '@/stockLibrary/config/consts'

type UserDesignInfo = {
  designVersionUuid: string
  designVersionImageUrl: string
  isDefault: boolean
}
export default Vue.extend({
  components: {
    SelectDesign,
    ProductGeneralInfo,
    ProductList,
    ProductCardGender,
    ProductDetail,
    DesignPreview,
    ProductEditPattern,
    Header,
    LandingModal,
    ModalIntroduction
  },
  props: {
    isCrossSell: {
      type: Boolean,
      default: false
    },
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  data(): {
    isLoading: boolean
    showSelectDesignModal: boolean
    showRemoveModal: boolean
    tutorialSteps: TutorialStep[]
    designImages: DesignImage[]
    categories: FullColorCategory[]
    defaultProducts: SimplifiedProductByCategory[]
    categoryEditPatterns: SimplifiedEditPattern[]
    userDesignInfo: UserDesignInfo | undefined
    selectedCategoryId: string
    selectedProductId: string
    loadingProductDetail: boolean
    productDetail: ProductDetailModel | null
    selectedEditPatternId: string
    selectedProductFirstOptionId: string
    showIntroductionModal: boolean
    showLandingModal: boolean,
    crossSellLogoDesign: string | null | undefined
    crossSellNamingEditors: readonly CrossSellNamingEditor[]
  } {
    return {
      isLoading: true,
      showSelectDesignModal: false,
      showRemoveModal: false,
      tutorialSteps: TUTORIAL_STEPS,
      designImages: [],
      categories: [],
      defaultProducts: [],
      categoryEditPatterns: [],
      selectedCategoryId: '',
      selectedProductId: '',
      loadingProductDetail: false,
      productDetail: null,
      showIntroductionModal: false,
      showLandingModal: false,
      userDesignInfo: undefined,
      selectedEditPatternId: '',
      selectedProductFirstOptionId: '',
      crossSellLogoDesign: '',
      crossSellNamingEditors: []
    }
  },
  computed: {
    productSelectedEditPattern(): ProductEditPatternModel | undefined {
      return this.productDetail?.sku.allSingleSkuEditPatterns.find(
        item => item.editPattern.id === this.selectedEditPatternId
      )
    },
    previewDesignKey(): string {
      return `${this.productSelectedEditPattern?.id}_${this.userDesignInfo?.designVersionImageUrl}`
    },
    productEditPatternIds(): string[] {
      return (
        this.productDetail?.sku.allSingleSkuEditPatterns.map(
          item => item.editPattern.id
        ) || []
      )
    },
    selectedCategoryName(): string {
      let result = ''
      for (const category of this.categories) {
        const childCategory = category.fullColorChildCategories?.find(
          item => item.id === this.selectedCategoryId
        )
        if (childCategory) {
          result = childCategory.displayName
          break
        }
      }
      return result
    }
  },
  async mounted() {
    if (this.isCrossSell && !LocalStorageSerializer.get(LOCAL_STORAGE_CROSS_SELL_MODAL_DISABLED)) {
      const crossSellData: CrossSellData = await getCrossSellData()

      if (crossSellData) {
        this.crossSellLogoDesign = crossSellData.crossSellLogoDesign?.imageUrl
        this.crossSellNamingEditors = crossSellData.crossSellLogoNamingEditors
        this.showIntroductionModal = true
      }
    } else {
      window.history.replaceState({}, document.title, '/design_simulator')
      this.showLandingModal = !LocalStorageSerializer.get(
        LOCAL_STORAGE_TUTORIAL_DISABLED
      )
    }
    this.isLoading = true

    const initData: StockLibraryInitRes = await getInitStockLibraryData()
    if (initData) {
      this.designImages = [...initData.userDesigns]
      this.categories = [...initData.fullColorCategories]
      this.defaultProducts = [...(initData.fullColorProductsByCategory?.products || [])]
      this.categoryEditPatterns = [...initData.editPatterns]
      if (this.designImages.length) {
        const defaultSelectDesign = this.designImages[0]
        this.userDesignInfo = {
          isDefault: defaultSelectDesign.isDefault,
          designVersionUuid: defaultSelectDesign.nonTransparentVersion?.uuid || '',
          designVersionImageUrl: defaultSelectDesign.nonTransparentVersion?.imageUrl || ''
        }
      }
      this.selectedCategoryId = initData.fullColorProductsByCategory?.category.id || ''

      if (this.defaultProducts.length) {
        this.setSelectedProduct(this.defaultProducts[0].id)
      }
    }

    this.isLoading = false
  },
  methods: {
    closeIntroductionModal() {
      this.showIntroductionModal = false
      window.history.replaceState({}, document.title, '/design_simulator')
      window.scrollTo(0, 0)
      LocalStorageSerializer.set(LOCAL_STORAGE_TUTORIAL_DISABLED, true)
      LocalStorageSerializer.set(LOCAL_STORAGE_CROSS_SELL_MODAL_DISABLED, true)
    },
    onChangeSelectedDesignImage(payload: UserDesignInfo) {
      this.userDesignInfo = payload
    },
    async setSelectedProduct(productId: string) {
      this.selectedProductId = productId
      this.loadingProductDetail = false
      const data: ProductDetailRes = await getProductDetail(
        this.selectedProductId
      ).finally(() => {
        this.loadingProductDetail = false
      })
      if (data) {
        this.productDetail = { ...data.productByPrintableSku }
        const matchedEditPattern =
          this.productDetail.sku.allSingleSkuEditPatterns.find(
            item => item.editPattern.id === this.selectedEditPatternId
          )
        if (!matchedEditPattern) {
          this.selectedEditPatternId =
            this.productDetail.sku.allSingleSkuEditPatterns[0].editPattern.id
        }
        this.selectedProductFirstOptionId =
          this.productDetail.sku.firstOptions[0].id
      }
    },
    async updateSelectedCategory(id: string) {
      this.selectedCategoryId = id
      const data: CategoryEditPatternRes = await getCategoryEditPatterns(
        this.selectedCategoryId
      )
      if (data) this.categoryEditPatterns = [...data.editPatterns]
    },
    updateSelectedEditPattern(id: string) {
      if (this.productEditPatternIds.includes(id)) {
        this.selectedEditPatternId = id
      }
    },
    async onChangeProductFirstOption(optionId: string) {
      this.selectedProductFirstOptionId = optionId
      const data: ProductEditPatternsRes =
        await getProductEditPatternsByFirstOption(
          this.selectedProductId,
          this.selectedProductFirstOptionId
        )
      if (data) {
        const updatedSku = {
          ...this.productDetail?.sku,
          allSingleSkuEditPatterns: data.productByPrintableSku.sku.allSingleSkuEditPatterns
        }
        Object.assign(this.productDetail, {
          sku: updatedSku
        })
      }
    }
  }
})
